import { LoadingButton } from '@mui/lab'
import { Typography } from '@mui/material'
import { webApiService } from '@services/index'
import MUIDataTable from 'mui-datatables'
import React, { useEffect, useState } from 'react'
import ModalOTList from './components/ModalOTList'

const DeliverySuppliesPage = () => {
  const [modal, setModal] = useState({ open: false, idSupply: 0, inventory: 0 })
  const [data, setData] = useState<any>([])

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'name',
      label: 'Nombre',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'cantidad_ot',
      label: 'Cantidad de solicitudes asignadas por OT',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'pendiente',
      label: 'Cantidad insumo pendiete entrega',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          const supply = data[tableMeta.rowIndex]
          return supply.cantidad_total - supply.entregados
        }
      }
    },
    {
      name: 'entregados',
      label: 'Entregados',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'inventory',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <LoadingButton variant='contained' color='warning' className='shadow-none' onClick={() => setModal({ open: true, idSupply: tableMeta.rowData[0], inventory: value })}>Entregar</LoadingButton>
          )
        }
      }
    }
  ]

  const loadData = async () => {
    const data = await webApiService.getSupplyForDelivery().then(res => res.data)
    console.log('Data de useEffect => ', data)
    setData(data)
  }

  useEffect(() => {
    if (!modal.open) {
      loadData()
    }
  }, [modal.open])

  return (
    <div>
      <div className='container-xxl '>
        <div className='row gy-3 my-4'>
          <div className='col-12 my-2'>
            <Typography variant='h6' className='title mb-3'>
              ENTREGA DE INSUMOS
            </Typography>

            <div className='shadow-sm rounded bg-white p-3'>
              <div className='tabla-ot' data-tour='tabla-ot'>
                <MUIDataTable
                  title=''
                  data={data}
                  columns={columns}
                  options={{ selectableRowsHideCheckboxes: true }}
                />
                {modal.open && <ModalOTList modal={modal} setModal={setModal} inventory={modal.inventory} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeliverySuppliesPage
